import {pickDefined} from '@sollapay/utils';

export type LoginContext =
  | {kind: 'member'; organization?: string}
  | {kind: 'guest'; loginHint?: string};

/**
 * `ext-` params are readable by the Universal Login template, which themes itself from
 * `ext-theme`; `theme` is omitted for hosts with no app theme.
 */
export function getLoginAuthorizationParams({
  locale,
  theme,
  context = {kind: 'member'}
}: {
  locale: string;
  theme?: string;
  context?: LoginContext;
}) {
  const themeParams = pickDefined({'ext-theme': theme});
  if (context.kind === 'guest') {
    // The guest client denies organizations; `connection` skips straight to the email-code screen.
    return {
      ui_locales: locale,
      connection: 'email',
      ...pickDefined({login_hint: context.loginHint}),
      ...themeParams
    };
  }
  // `organization` stays a key even when undefined so it overrides the Auth0Provider default captured at mount.
  return {ui_locales: locale, organization: context.organization, ...themeParams};
}
